import React, { useState } from 'react';
import ReservationRequired from 'src/assets/images/Menu/ReservationRequired.svg';
import PropTypes from 'prop-types';
import {
    ItemsCardContainer,
    CheckBoxContainer,
    RowContainer,
    ColumnContainer,  
    ProductTemplateDetailsHeader,
    WarningText,
    WarningTextContainer,
    WarningTextType,
    CartContainer,
    LineSeparator,
    WarningDiv,
    Flex,
    NoShipText,
    BatchText,
} from './SetsAndItems.styled';
import {
    avoidDeploymentType,
    logErrorToConsole,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CreatedByUser from 'src/assets/images/CreatedByUser.svg';
import FavoriteActive from 'src/assets/images/FavoriteActive.svg';
import FavoriteInactive from 'src/assets/images/favorite-inactive.svg'; 
import { useSelector } from 'react-redux';  
import FlagRed from 'src/assets/images/AlertWarningMessage.svg'; 
import {
    CommonItemsContainer,
    CommonItemsMainContainer,
} from 'src/pages/more/pages/common/templateDetails/TemplateDetails.styled.jsx';  
import PriceDetailsRow from 'src/common/organisms/setsanditems/components/PriceDetailsRow';
import ShippingDetails from 'src/common/organisms/setsanditems/components/ShippingDetails';
import Description from 'src/common/organisms/setsanditems/components/Description';
import CardFooterContainer from 'src/common/organisms/setsanditems/components/CardFooterContainer';
import NameContainer from 'src/common/organisms/setsanditems/components/NameContainer';
import { BASE_TEXT_PX, DARK_NAVY_FONT_COLOR, ORANGE_FONT_COLOR, SEMANTIC_TEXT_PX, TITLE_FONT_COLOR } from '../../../styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const SetsAndItems = (props) => {

        const { 
            isconsignmentAddOrder=false,
            inputOnChange,
            subitem = false,
            handleSetSelection, 
            isTemplate=false,
            isTemplateScreen = false,
            isFromTemplates = false,
            orderType,
            moreTemplates,
            templateDetails,
            notes,
            setsQuantityCheck,
            isEquityNT,
            isEquityOrder,
            templateUID,
            isInstantFavorite,
            enableTemplateCardSpecificStyling,
            cardFooterWidth,
            children,
            setOrItemDetails,
            checkBoxDetails,
            addBorder,
            addfullBorder,
            minWidth,
            landscapeMinWidth,
            isQuantity,
            isCounterButton,
            isOnlyPlusButton,
            isFromIndependentProductGuide,
            removeCount,
            addCount,
            addCard=()=>{},
            onSetItemClick,
            onBomClick,
            boxShadow,
            itemQuantity,
            showType,
            productTemplate,
            margin,
            showBrand,
            isFromCart,
            showStatus,
            showHome,
            opentemplate,
            showPhysicianAndAccountInsteadOfSetDetails,
            fontSize,
            marginOnLargeDevice,
            marginOnMediumDevice,
            marginRight,
            typeFontSize,
            shippingRequirement,
            contentPadding,
            setNameColor,
            setNameFontSizeDesktop,
            setNameFontSizeMobile,
            clickable,
            setNameLetterSpacing,
            itemCardsContainerMinMobWidth,
            width,
            mobileWidth, 
            setOrItemDetailsFontSizeDesktop,
            cartFooterMargin,
            favoriteOrUnfavorite = () => {},
            mbWidth,
            mbHeight,
            setDescriptionMinWidth,
            isEquity = false,
            accountsList,
            height,  
            alignSelfBrand,  
            moreProductGuide, 
            isSurgery,
            isPlaceHolder,
            isScheduleSurgery,
            setNameWidth,
            setNameTextOverflow,
            setNameOverflow,
            setNameStyle,
            displayReservationMsg = false,
            waringMessage,
            selectedSegment = 0,
            priceMarginTop,
            id, 
            productSearchFlag, 
            bundlePopUpFlag = false,
            widthItem,
            marginOnMobileDevice, 
            tabDeviceWidth,
            tabDeviceLandscapeWidth, 
            reviewPage,
            priceOverridePage,
            tabWidthPotrait,
            clipPath,
            minMobileWidth,
            updateItemsCount,
            parentIndex,
            index,
            quickOrderFlag, 
            handleDeleteProducts,
            handleBundleSubItemDelete,
            cartPage=false,
            materialType,
            setIsQuantityMoreThan50=()=>{}, 
            isConsignmentAdd=false,
            isEquityProductGuide=false,
            isEquityProductSearch=false,
            isBundle,
            childRemoveCount,
            childAddCount,
            isClickable,
            handleBundleDelete,
            isBundleSubItem,
            handleBundlePopup,
            isOrderDetail,
            isExtraItem,
            isProductTemplate=false,
            marginBottom,
            isEquityTemplate=false,
            mbFlexDirection,
            setFavoriteIconTop=false,
            isReviewSubmitScreen= false,
            } = props;
    const {
        productCFN,
        cfn,
        quantity,
        setDetails,
        brand,
        uom,
        status,
        physicianName,
        physicianId,
        accountName,
        accountId,
        type,
        isSet,
        description,
        productTemplateHeader,
        createdBy,
        createdDate,
        productTemplateProcedure,
        bom, 
        home,
        productAdded,
        batchParked,
        batchCurrentLocation,
        batchAlreadyAllocated,
        batchId,
        isFavourite,
        totalAccountCount,
        totalPhysicianCount,
        isPlaceHolderAdded,
        isDeleteButtonPresent,
        isReservationSet,  
        productKey,
        bundleItems,
        isChecked,
        salesOrg,
        basePrice,
        extPrice,
        discount,
        adjustedUnitPrice,
        adjustedExtPrice,
        children: setOrItemChildren ,
        reservationBatchCurrentLocation,
        reservationBatchId,
    } = setOrItemDetails || {};  

    const [checkBoxInfo, setCheckBoxInfo] = useState({});
    const [quantityValue, setQuantityValue] = useState(quantity || 0);
    const [, setSelectedBundleProducts] = useState([]); 
    const [expandedCard, setExpandedCard] = useState({
            itemDetails: false,
        });
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    ); 
    const productWithIsPlaceHolderSet = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsPlaceHolderSet
    );
    const productWithIsDeleteButtonPresent = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsDeleteButtonPresent
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const { productBomDetails } = useSelector(
        (state) => state.checkProductBomReducer
    );
        
    const [bomdata, setBomData] = useState([]);

    const bundleChildren = isOrderDetail? bundleItems :setOrItemChildren;

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    useEffectWithErrorLogging(() => {
        setCheckBoxInfo({
            ...checkBoxDetails,
        });
        return () => {};
    }, [checkBoxDetails]);

    useEffectWithErrorLogging(() => {
        setQuantityValue(quantity);
        return () => {};
    }, [quantity]);

    useEffectWithErrorLogging(() => {
        addChildrenCheckedStatusToProducts();
    }, [isChecked]);

    const[loaderFlag, setLoaderFlag] = useState(false);

    const addCountTocard = () => {
    setLoaderFlag(true);
    addCard();
    setTimeout(() => {
        try {
            setLoaderFlag(false);
        }
        catch (error) {
            logErrorToConsole(error);
        }
    }, 3000);
    };

    useEffectWithErrorLogging(()=>{
    setLoaderFlag(false);
    },[productAdded]);

    const validateQuantity = (value) => {
        const limitFourDigits = /^[\d]{0,2}$/;

        (isEquityOrder || isConsignmentAdd) && parseInt(value) > 50 && 
        !priceOverridePage && setIsQuantityMoreThan50(true);

        if (
            limitFourDigits.test(value) &&
            (parseInt(value) <= 50 || value == '')
        ) {
            setQuantityValue(value);
            value != '' &&
                (subitem || priceOverridePage
                    ? inputOnChange(value, productKey)
                    : inputOnChange(value));
        }
    };
    
    const addChildrenCheckedStatusToProducts = () => {
        let productListWithCheckedStatus = {
            bundleProducts: bundleItems?.map((product) => {
                return {
                    ...product,
                    isChecked: isChecked,
                };
            }),
        };
        setSelectedBundleProducts(productListWithCheckedStatus);
    };

    useEffectWithErrorLogging(() => {
        if (productBomDetails && Array.isArray(productBomDetails)) {
            const filteredData = productBomDetails.filter(
                (item) => item.billOfMaterialsHistory
            );
            setBomData(filteredData);
        }
    }, [productBomDetails]);

    const { t } = useTranslation();
    useEffectWithErrorLogging(() => {
        setCheckBoxInfo({
            ...checkBoxDetails,
        });
        return () => {};
    }, [checkBoxDetails]);

    return (
        <>
            <ItemsCardContainer
                boxShadow={boxShadow}
                border={{ border: addBorder }}
                fullBorder={addfullBorder}
                minWidth={{ minWidth: minWidth }}
                landscapeMinWidth={{ landscapeMinWidth: landscapeMinWidth }}
                margin={margin}
                marginOnLargeDevice={marginOnLargeDevice}
                marginOnMediumDevice={marginOnMediumDevice}
                marginOnMobileDevice={marginOnMobileDevice}
                minMobileWidth={minMobileWidth}
                width={width}
                mobileWidth={mobileWidth}
                itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidth}
                height={height}
                onClick={() => {
                    moreProductGuide && onSetItemClick(setOrItemDetails);
                }}
                enableTemplateCardSpecificStyling={
                    enableTemplateCardSpecificStyling
                }
                widthItem={widthItem}
                tabDeviceWidth={tabDeviceWidth}
                tabDeviceLandscapeWidth={tabDeviceLandscapeWidth}
                backgroundColor={subitem ? '#FBFAFF' : null}
                tabWidthPotrait={tabWidthPotrait}
                clipPath={clipPath}
                id={'set-item-card-container-' + (cfn || bom || productCFN)}
            >
                { checkBoxDetails &&(
                    <CheckBoxContainer>
                        <Checkbox
                            name={checkBoxInfo.name}
                            onCheckboxSelectionChange={() => {
                                const nextChecked = !checkBoxInfo.checked;
                                setCheckBoxInfo({
                                    ...checkBoxInfo,
                                    checked: nextChecked,
                                });
                                checkBoxDetails.onChange(nextChecked);
                            }}
                            checked={checkBoxInfo.checked}
                            id={checkBoxInfo.id}
                            disabled={productWithIsPlaceHolderSet?.some(
                                (data) => data.cfn === cfn
                            )}
                            background={'none'}
                            checkboxBorder={'1.5px solid #555555'}
                            alignItemDirection={'center'}
                            hoverEffect={'false'}
                            disableFocusEffect={'true'}
                            margin={'0px 0px 0px 10px'}  
                            width = {reviewPage || priceOverridePage && '100%'}
                            style={{display: 'flex'}}
                        />
                    </CheckBoxContainer>
                )}

                <RowContainer
                    contentPadding={contentPadding}
                    enableTemplateCardSpecificStyling={
                        enableTemplateCardSpecificStyling
                    }
                >
                    <ColumnContainer 
                        justifyContent={(((isBundle && isOrderDetail) 
                            || (isBundleSubItem && !cartPage)) && !isEquityTemplate)? 'flex-start': 
                         (isBundleSubItem && cartPage && isEquityOrder)|| isEquityTemplate? 'space-between':''
                        }>
                        <NameContainer 
                            isBundle = {isBundle}
                            templateDetails={templateDetails}
                            isTemplate={isTemplate}
                            isEquityTemplate={isEquityTemplate}
                            isProductTemplate={isProductTemplate}
                            setFavoriteIconTop={setFavoriteIconTop}
                            //templateDetails={templateDetails}
                            //isEquityTemplate={isEquityTemplate}
                            quickOrderFlag ={quickOrderFlag}
                            setOrItemChildren={setOrItemChildren}
                            isOrderDetail={isOrderDetail}
                            expandedCard={expandedCard}
                            toggleCard={toggleCard}
                            productCFN={productCFN}
                            productKey={productKey}
                            cfn={cfn}
                            bom={bom}
                            onSetItemClick={onSetItemClick}
                            setOrItemDetails={setOrItemDetails}
                            setNameColor={setNameColor}
                            clickable={clickable}
                            isEquityOrder={isEquityOrder}
                            isConsignmentAdd={isConsignmentAdd}
                            setNameFontSizeDesktop={setNameFontSizeDesktop}
                            setNameFontSizeMobile={setNameFontSizeMobile}
                            setNameLetterSpacing={setNameLetterSpacing}
                            enableTemplateCardSpecificStyling={enableTemplateCardSpecificStyling}
                            setNameWidth={setNameWidth}
                            setNameTextOverflow={setNameTextOverflow}
                            setNameOverflow={setNameOverflow}
                            setNameStyle={setNameStyle}
                            priceOverridePage={priceOverridePage}
                            reviewPage={reviewPage}
                            salesOrg = {salesOrg}
                            uom ={uom}
                            type={type}
                            isBundleSubItem={isBundleSubItem}
                            isEquityProductGuide={isEquityProductGuide}
                            cartPage={cartPage}
                            isconsignmentAddOrder={isconsignmentAddOrder}
                            isFromIndependentProductGuide={isFromIndependentProductGuide}
                            productTemplateHeader={productTemplateHeader}
                            isCounterButton={isCounterButton}
                            isOnlyPlusButton={isOnlyPlusButton}
                            isQuantity={isQuantity}
                            quantity={quantity}
                            marginRight={marginRight}
                            fontSize={fontSize}
                            bundleItems={bundleItems}
                            bomdata={bomdata}
                            isFromCart={isFromCart}
                            onBomClick={onBomClick}
                            id={id}
                            opentemplate={opentemplate}
                            isEquity={isEquity}
                            countryISOCode={countryISOCode}
                            isEquityNT={isEquityNT}
                            isSet={isSet}
                            typeFontSize={typeFontSize}
                            addCountTocard={addCountTocard}
                            loaderFlag={loaderFlag}
                            productAdded={productAdded}
                            isLanguageChanged={isLanguageChanged}
                            selectedSegment={selectedSegment}
                            productWithIsDeleteButtonPresent={productWithIsDeleteButtonPresent}
                            productWithIsPlaceHolderSet={productWithIsPlaceHolderSet}
                            isPlaceHolder={isPlaceHolder}
                            isPlaceHolderAdded={isPlaceHolderAdded}
                            isDeleteButtonPresent={isDeleteButtonPresent}
                            removeCount={removeCount}
                            quantityValue={quantityValue}
                            subitem={subitem}
                            updateItemsCount={updateItemsCount}
                            parentIndex={parentIndex}
                            index={index}
                            validateQuantity={validateQuantity}
                            setIsQuantityMoreThan50={setIsQuantityMoreThan50}
                            isSurgery={isSurgery}
                            setsQuantityCheck={setsQuantityCheck}
                            addCount={addCount}
                            createdBy={createdBy}
                            favoriteOrUnfavorite={favoriteOrUnfavorite}
                            isFavourite={isFavourite}
                            FavoriteActive={FavoriteActive}
                            FavoriteInactive={FavoriteInactive}
                        />
                    </ColumnContainer>
                    {productTemplate}
                    {productTemplateProcedure ? (
                        <ProductTemplateDetailsHeader>
                            {productTemplateProcedure}
                        </ProductTemplateDetailsHeader>
                    ) : enableTemplateCardSpecificStyling ? (
                        <ProductTemplateDetailsHeader />
                    ) : null}{' '}
                    {/* 10-20mm text */}

                    <Description
                        isEquityOrder = {isEquityOrder}
                        isEquityTemplate={isEquityTemplate}
                        isProductTemplate = {isProductTemplate}
                        //isEquityTemplate={isEquityTemplate}
                        isBundle = {isBundle}
                        cartPage = {cartPage}
                        showPhysicianAndAccountInsteadOfSetDetails = {showPhysicianAndAccountInsteadOfSetDetails}
                        totalAccountCount = {totalAccountCount}
                        totalPhysicianCount = {totalPhysicianCount}
                        isEquity = {isEquity}
                        isConsignmentAdd = {isConsignmentAdd}
                        accountName = {accountName}
                        accountId = {accountId}
                        accountsList = {accountsList}
                        bom = {bom}
                        cfn = {cfn}
                        productCFN = {productCFN}
                        onSetItemClick = {onSetItemClick}
                        setOrItemDetails = {setOrItemDetails}
                        physicianName = {physicianName}
                        physicianId = {physicianId}
                        isconsignmentAddOrder = {isconsignmentAddOrder}
                        setDescriptionMinWidth = {setDescriptionMinWidth}
                        mbHeight = {mbHeight}
                        mbWidth = {mbWidth}
                        reviewPage = {reviewPage}
                        templateDetails = {templateDetails}
                        isOrderDetail = {isOrderDetail}
                        setOrItemDetailsFontSizeDesktop = {setOrItemDetailsFontSizeDesktop}
                        notes = {notes}
                        setDetails = {setDetails}
                        description = {description}
                        priceOverridePage = {priceOverridePage}
                        quantityValue = {quantityValue}
                        quantity = {quantity}
                        validateQuantity = {validateQuantity}
                        productSearchFlag = {productSearchFlag}
                        isEquityProductGuide = {isEquityProductGuide}
                        bundleItems = {bundleItems}
                        isScheduleSurgery = {isScheduleSurgery}
                        salesOrg = {salesOrg}
                        isBundleSubItem = {isBundleSubItem}
                        bundlePopUpFlag = {bundlePopUpFlag}
                        subitem = {subitem}
                        uom = {uom}
                        type = {type}
                        marginBottom= {marginBottom}
                    />

                    {children}
                    
                    <CardFooterContainer
                        isExtraItem={isExtraItem}
                        isEquityTemplate={isEquityTemplate}
                        isReservationSet={isReservationSet}
                        setFavoriteIconTop={setFavoriteIconTop}
                        //isEquityTemplate={isEquityTemplate}
                        cartFooterMargin={cartFooterMargin}
                        cardFooterWidth={cardFooterWidth}
                        isPlaceHolder={isPlaceHolder}
                        isPlaceHolderAdded={isPlaceHolderAdded}
                        displayReservationMsg={displayReservationMsg}
                        isOrderDetail={isOrderDetail}
                        home={home}
                        brand={brand}
                        uom={uom}
                        status={status}
                        showBrand={showBrand}
                        isEquity={isEquity}
                        enableTemplateCardSpecificStyling={enableTemplateCardSpecificStyling}
                        isEquityOrder={isEquityOrder}
                        type={type}
                        isBundle={isBundle}
                        alignSelfBrand={alignSelfBrand}
                        isConsignmentAdd={isConsignmentAdd}
                        orderType={orderType}
                        cartPage={cartPage}
                        showType={showType}
                        showHome={showHome}
                        showStatus={showStatus}
                        isSet={isSet}
                        itemQuantity={itemQuantity}
                        quantity={quantity} 
                        isEquityProductSearch={isEquityProductSearch}
                        setNameColor={setNameColor}
                        clickable={clickable}
                        setNameFontSizeDesktop={setNameFontSizeDesktop}
                        setNameLetterSpacing={setNameLetterSpacing}
                        handleBundlePopup={handleBundlePopup}
                        onSetItemClick={onSetItemClick}
                        setOrItemDetails={setOrItemDetails}
                        materialType={materialType}
                        isBundleSubItem={isBundleSubItem}
                        handleBundleSubItemDelete={handleBundleSubItemDelete}
                        handleBundleDelete={handleBundleDelete}
                        handleDeleteProducts={handleDeleteProducts}
                        moreTemplates={moreTemplates}
                        createdBy={createdBy}
                        CreatedByUser={CreatedByUser}
                        createdDate={createdDate}
                        favoriteOrUnfavorite={favoriteOrUnfavorite}
                        isFavourite={isFavourite}
                        FavoriteActive={FavoriteActive}
                        FavoriteInactive={FavoriteInactive}
                        isScheduleSurgery={isScheduleSurgery}
                        mbFlexDirection={mbFlexDirection}
                    />
                                           
                    {isEquityOrder &&
                    <ColumnContainer flexDirection = {isBundle? 'column':''}
                     marginTop = {cartPage && '5px'}>
                        {isBundle && !isOrderDetail? <LineSeparator /> : null}
                        {(!productSearchFlag && !subitem) || isBundle? (
                            
                           <PriceDetailsRow
                               priceMarginTop={priceMarginTop}
                               basePrice={basePrice}
                               isBundle={isBundle}
                               setOrItemChildren={setOrItemChildren}
                               quickOrderFlag={quickOrderFlag}
                               discount={discount}
                               adjustedUnitPrice={adjustedUnitPrice}
                               extPrice={extPrice}
                               adjustedExtPrice={adjustedExtPrice}
                           />
                        ) : null}

                        {expandedCard.itemDetails ? (
                            <CartContainer
                                padding={'0 0 0 0'}
                                display={'unset'}
                                height={bundleChildren?.length > 2 && '226px'}
                                marginBottom={bundleChildren?.length > 2 && '8px'}
                                overflowY={bundleChildren?.length > 2 && 'scroll'}
                            >
                                {bundleChildren &&
                                    bundleChildren?.map((item, index) => {
                                        return (
                                            <SetsAndItems
                                                cartPage={cartPage}
                                                marginOnLargeDevice={
                                                    '6px auto 10px auto'
                                                }
                                                isBundleSubItem
                                                marginOnMediumDevice={
                                                    '0 30px 7px 0'
                                                }
                                                marginOnMobileDevice={
                                                    '0px auto 0px auto'
                                                }
                                                key={`${item.cfn}-${index}`}
                                                isCounterButton={isOrderDetail? false: true}
                                                minWidth={'100%'}
                                                setOrItemDetails={item}
                                                removeCount={(quantityValue) =>
                                                    item.quantity > 0 &&
                                                    childRemoveCount(
                                                        item.productKey,
                                                        quantityValue
                                                    )
                                                }
                                                addCount={(quantityValue) =>
                                                    childAddCount(
                                                        item.productKey,
                                                        quantityValue
                                                    )
                                                }
                                                cardType={'sets'}
                                                count={item.count}
                                                showBrand={true}
                                                margin={'0 3px'}
                                                setNameColor= {DARK_NAVY_FONT_COLOR}
                                                setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                                                setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                                                itemCardsContainerMinMobWidth={
                                                    '95%'
                                                }
                                                addfullBorder={
                                                    '0.5px solid #F5E2FF'
                                                }
                                                // onSetItemClick={
                                                //     handleSetItemClick
                                                // }
                                                clickable={
                                                    isClickable ? true : false
                                                }
                                                subitem={subitem}
                                                productSearchFlag={true}
                                                widthItem={'100%'}
                                                inputOnChange={inputOnChange}
                                                clipPath={
                                                    'inset(-1px -1px -8px -1px)'
                                                }
                                                updateItemsCount={updateItemsCount}
                                                parentIndex={parentIndex}
                                                index={index}
                                                quickOrderFlag={quickOrderFlag}
                                                handleBundleDelete={
                                                    handleBundleDelete
                                                }
                                                handleBundleSubItemDelete={(
                                                    isDeleteClicked
                                                ) =>
                                                    handleBundleSubItemDelete(
                                                        productKey,
                                                        item.productKey,
                                                        isDeleteClicked
                                                    )
                                                }
                                                materialType={materialType}
                                                setIsQuantityMoreThan50={
                                                    setIsQuantityMoreThan50
                                                }
                                                isEquityTemplate={isEquityTemplate}
                                                setDescriptionMinWidth={isEquityTemplate? '180px':''}
                                                isEquityOrder
                                                //isEquityTemplate={isEquityTemplate}
                                                //setDescriptionMinWidth={isEquityTemplate? '180px':''}
                                            />
                                        );
                                    })}
                            </CartContainer>
                        ) : null}
                    </ColumnContainer>}

                    {/* Bundle items rendering for all use cases */}
                    {(bundleItems && !isOrderDetail && !isFromTemplates && isTemplateScreen)? (
                        <CommonItemsMainContainer mobileMargin={'0px 16px 0px 16px'} marginLeft={'-35px'}>
                            {bundleItems?.map((item, index) => {
                                item.type = item?.uom ? item.uom : t('orders.shipTrackLabels.eaLabel');
                                return (
                                    <CommonItemsContainer marginTop={'0px'} mbMarginTop={'10px'} key={`item${index}`} hideMargin alignItemsCenter>
                                        <SetsAndItems
                                            setNameFontSizeDesktop={BASE_TEXT_PX}
                                            setNameFontSizeMobile={BASE_TEXT_PX}
                                            clickable={true}
                                            key={`item${index}`}
                                            setOrItemDetails={item}
                                            margin={'0px'}
                                            showBrand={true}
                                            isQuantity={true}
                                            setNameColor={TITLE_FONT_COLOR}
                                            checkBoxDetails={
                                                (!isFromTemplates || isEquity ||
                                                isEquityOrder || isConsignmentAdd) && !isOrderDetail ? {
                                                name: item.cfn,
                                                id: item.description,
                                                onChange: (isChecked) => {
                                                    handleSetSelection(
                                                        item.cfn,
                                                        !item.isChecked,
                                                        'children',
                                                        productKey,
                                                        isChecked
                                                    );
                                                },
                                                checked: item.isChecked,
                                            } : null}
                                            onSetItemClick={(product, isBack) => {
                                                onSetItemClick && onSetItemClick(
                                                    product,
                                                    isBack,
                                                    templateUID ? { [templateUID]: isInstantFavorite } : undefined
                                                );
                                            }}
                                            boxShadow={'0'}
                                            marginRight={'20px'}
                                        />
                                    </CommonItemsContainer>
                                );
                            })}
                        </CommonItemsMainContainer>
                    ) : null}

                    {waringMessage && waringMessage?.length > 0
                        ? waringMessage.map((msg, index) => {
                              return (
                                  <WarningDiv
                                      key={index} 
                                  >
                                      {' '}
                                      <WarningTextContainer padding={'5px 0 5px 0'}>
                                          {' '}
                                          <img
                                              src={FlagRed}
                                              alt="icon"
                                              height={'20px'}
                                              width={'20px'}
                                              style={{
                                                  color: ORANGE_FONT_COLOR,
                                                  //   marginRight: '5px',
                                              }}
                                          />{' '}
                                          <Flex>
                                              <WarningTextType>
                                                  {msg.messageType}
                                                  {' - '}{' '}
                                              </WarningTextType>
                                              <WarningText>
                                                  {' '}
                                                  {msg.messageText}{' '}
                                              </WarningText>{' '}
                                          </Flex>
                                      </WarningTextContainer>{' '}
                                  </WarningDiv>
                              );
                          })
                        : null}
                    {shippingRequirement ? (
                        <ShippingDetails
                            isScheduleSurgery={isScheduleSurgery}
                            shipDontShipSurgery={shipDontShipSurgery}
                            batchCurrentLocation={batchCurrentLocation}
                            batchId={batchId}
                            isEquity={isEquity}
                            isConsignmentAdd={isConsignmentAdd}
                            shippingRequirement={shippingRequirement}
                            avoidDeploymentType={avoidDeploymentType}
                            countryISOCode={countryISOCode}
                            batchParked={batchParked}
                            isEquityOrder={isEquityOrder}
                            batchAlreadyAllocated={batchAlreadyAllocated}
                            isReservationSet={isReservationSet}
                            reservationBatchCurrentLocation={reservationBatchCurrentLocation}
                            reservationBatchId={reservationBatchId}
                        />
                    ) : isScheduleSurgery && isReservationSet && isReviewSubmitScreen && (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                }}
                            >
                                <img
                                    src={ReservationRequired}
                                    alt="ReservationRequired"
                                    width="20px"
                                    height="20px"
                                    style={{ marginRight: '1%' }}
                                />
                                <NoShipText
                                    color={isReservationSet && '#C121EB'}
                                >
                                    {t(
                                        'scheduleSurgery.Shipping.ProductCard.reservationRequested'
                                    )}
                                </NoShipText>
                            </div>
                            {reservationBatchId === 'Batch Not Found' ? (
                                <BatchText
                                    width={'100%'}
                                    paddingBottom={'12px'}
                                >
                                    {t(
                                        'scheduleSurgery.Shipping.ProductCard.batchNotFound'
                                    )}
                                </BatchText>
                            ) : (
                                <BatchText
                                    width={'100%'}
                                    paddingBottom={'12px'}
                                >
                                    {reservationBatchCurrentLocation
                                        ? `${t(
                                              'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                          )} ${reservationBatchId}: ${reservationBatchCurrentLocation}`
                                        : `${t(
                                              'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                          )} ${reservationBatchId}`}
                                </BatchText>
                            )}
                        </>
                    )}
                </RowContainer>
            </ItemsCardContainer>
        </>
    );
};

SetsAndItems.prototype = {
    setOrItemDetails: PropTypes.object,
    checkBoxDetails: PropTypes.object,
};

export default SetsAndItems;
